import React from 'react';
import { Image as ChakraImage } from '@chakra-ui/react';

function UncontrolledImage({ imageKey, lazy = true, ...props }) {
  return (
    <ChakraImage
      draggable={false}
      src={imageKey}
      width="100%"
      height="100%"
      loading={lazy ? 'lazy' : undefined}
      {...props}
    />
  );
}

export default UncontrolledImage;
